// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
'use strict';
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
export class SubscribeNewsGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.SUBSCRIBE_NEWS_GROUP, null, pfixFieldSet);
    }
    getRouteId() {
        return this.GetValue(FieldsFactory.FIELD_ROUTE_ID);
    }
    setRouteId(routeID) {
        this.SetField(FieldsFactory.FIELD_ROUTE_ID, routeID);
    }
}
